import data from '../data/data.json';
import { Animation } from './Animation';
import { Stats } from './Stats';
import Sortable from 'sortablejs/modular/sortable.complete.esm.js';


export class Starting {
    constructor() {

        this.debugMode = false;

        //Base
        this.nextButton = [...document.querySelectorAll('.next')];
     
        // Pastille
        this.pastilleContent = document.querySelector('.pastille-content p')
        this.pastilleContentBtn = document.querySelector(".pastille-content .box button")
        this.pastilleContainer;
        this.pastille;

        this.clipPathStart = document.querySelector('.start-path')

        //Game 1
        this.sectionOne;
        this.slider;
        this.min = document.querySelector('.min');
        this.max = document.querySelector('.max');
        this.validateOneBtn = document.querySelector('.validate-one')
        this.buttonOvales = document.querySelectorAll('.btn-ovale')
        this.validateArrow = document.querySelectorAll('.arrow-ovale')
        this.sectionOne = document.querySelector('.jeu-1')
        this.phraseGame1 = document.querySelector('.jeu-1 .phrase')
        this.sourceGame1 = document.querySelector('.jeu-1 .source')
        this.repSlider = document.querySelector('.rep-slider')

        //Game 2
        this.sectionTwo = document.querySelector('.jeu-2')
        this.phraseGame2 = document.querySelector('.jeu-2 .phrase')
        this.sourceGame2 = document.querySelector('.jeu-2 .source')
        this.qcmZone2 = document.querySelector('.jeu-2 .qcmZone')

        //Game 3
        this.sectionThree = document.querySelector('.jeu-3')
        this.phraseGame3 = document.querySelector('.jeu-3 .phrase')
        this.sourceGame3 = document.querySelector('.jeu-3 .source')
        this.qcmZone3 = document.querySelector('.jeu-3 .qcmZone')

        //Game 4
        this.sectionFour = document.querySelector('.jeu-4')
        this.phraseGame4 = document.querySelector('.jeu-4 .phrase')
        this.zoneDrag =  document.querySelector('.jeu-4 .zoneDrag')
        this.zoneDraggableEl =  document.querySelector('.jeu-4 .zoneElements')
        this.sourceGame4 = document.querySelector('.jeu-4 .source')
        this.ponctuationZone4 = document.querySelector('.jeu-4 .ponctuationZone4')
        this.validateDrag = document.querySelector('.jeu-4 .validate-drag')
        this.draggable4 = document.querySelector('.jeu-4 .draggable4')

        //Game 5
        this.sectionFive = document.querySelector('.jeu-5')
        this.phraseGame5 = document.querySelector('.jeu-5 .phrase')
        this.sourceGame5 = document.querySelector('.jeu-5 .source')
        this.ponctuationZone5 = document.querySelector('.jeu-5 .ponctuationZone5')
        this.validatePonctuation = document.querySelector('.jeu-5 .validate-ponctuation')

        //Game 6
        this.sectionSix = document.querySelector('.jeu-6')
        this.phraseGame6 = document.querySelector('.jeu-6 .phrase')
        this.sourceGame6 = document.querySelector('.jeu-6 .source')
        this.qcmZone6 = document.querySelector('.jeu-6 .qcmZone')

        // Bonne rep
      
        this.bonneRepView = document.querySelector('.bonne-rep-view')
        this.bonWrapper = document.querySelector('.bonne-rep-view .wrapper');
    

        this.bonneRepGGF;
        this.bonneRepMention;
        this.bonneRepComplementaire;
        this.bonneRepMots;

        // Mauvaise rep
        this.mauvaiseRepView =  document.querySelector('.mauvaise-rep-view')
        this.badWrapper = document.querySelector('.mauvaise-rep-view .wrapper');
        this.goodContentRecap = document.querySelector('.bonne-rep-view .content-view');
        this.badContentRecap = document.querySelector('.mauvaise-rep-view .content-view');
        
        this.mauvaiseRepMention;
        this.mauvaisRepComplementaire;
        this.mauvaiseRepGGF;
        this.mauvaiseRepMots;

        // Game info
        this.gameInformations = document.querySelector('.game-infos');
        this.consigne = document.querySelector('.consigne');
        this.id = document.querySelector('.gameId .id');

        // Recap
        this.recap = document.querySelector('.recap')


        //Replay
        this.replayBtn = document.querySelector('.replay')
        this.hero = document.querySelector('.hero')
        
        // Son
        this.sound = false;

      
        // Score
        this.score = 0;
      
        this.finalData = [];
        this.data = data

        this.tempPhrase;
        this.animation = new Animation();
    
        
    }

    replay() {
        
    
        this.randomizer()
        this.firstGame()
    }

    init() {
        new Stats()

       

        // Home
        this.startBtn = document.querySelector('.start')

        this.testingBtn = document.querySelector('.start-test')

        if(window.matchMedia( "(max-width: 425px)" ).matches) {
            this.animation.loading(5, 10, {y1:0, y2: 0, y3: 0, h:"500px" })

        } else if(window.matchMedia( "(min-width: 426px) and (max-width: 991px)" ).matches) {
            this.animation.loading(20, 80, {y1:0, y2: 0, y3: 0, h:"50vh" })

        } else if(window.matchMedia( "(min-width: 992px) and (max-width: 1100px)").matches) {
                this.animation.loading(50, 200, {y1:0, y2:0, y3: 0, h:"40vh" })

        } else if(window.matchMedia( "(min-width: 1101px)").matches) {
            this.animation.loading(50, 200, {y1:200, y2: 100, y3: 50, h:"20vh" })
        } 



        this.randomizer()

        this.startBtn.addEventListener('click', ()=> {
            
            this.firstGame()
           
        }, {once:true})
        
       

        //  this.acceptStats = document.querySelector('.accept')

        // this.acceptStats.addEventListener('click', ()=> {
            
        //     new Stats()

        //     document.querySelector('.c-banner').classList.add('hideCbanner')
           
        // }, {once:true})
        
    }   

  



    dynamicMetaOG() {
    

        this.text = `J'ai obtenu ${this.score}/4 aux mini-jeux de La Grande Grammaire du Français!`
        this.newText = encodeURI(this.text)
        this.newText.replace(/'/g, "%27")
        
        
        this.linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`
        this.facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`;
        this.twitterUrl = `https://twitter.com/intent/tweet?text=${this.newText}&url=https://jeux.grandegrammairedufrançais.com/`;


        this.facebookEl = document.querySelector('.facebook')
        this.facebookEl.href = this.facebookUrl;

        this.linkedInEl = document.querySelector('.linkedin')
        this.linkedInEl.href = this.linkedInUrl; 

        this.twitterEl = document.querySelector('.twitter')
        this.twitterEl.href =this.twitterUrl;
    
    }

    firstGame() {
        if(this.finalData[0].gameId === 1) {
            this.gameOne();
            this.animation.homepage(this.hero, this.sectionOne, this.finalData[0].gameId)
        } else if(this.finalData[0].gameId === 2) {
            this.gameTwo()
            this.animation.homepage(this.hero, this.sectionTwo, this.finalData[0].gameId)
        } else if(this.finalData[0].gameId === 3) {
            this.gameThree()
            this.animation.homepage(this.hero, this.sectionThree, this.finalData[0].gameId)
        } else if(this.finalData[0].gameId === 4) {
            this.gameFour()
            this.animation.homepage(this.hero, this.sectionFour, this.finalData[0].gameId)
        } else if(this.finalData[0].gameId === 5) {
            this.gameFive()
            this.animation.homepage(this.hero, this.sectionFive, this.finalData[0].gameId)
        } else if(this.finalData[0].gameId === 6) {
            this.gameSix()
            this.animation.homepage(this.hero, this.sectionSix, this.finalData[0].gameId)
        }
    }

   
    
    gameInfos(consigne, id, titre) {
        this.consigne.innerHTML = consigne;
        this.id.innerHTML = id;
    }

    randomizer() {


        this.gameTotal = [1, 2, 3, 4, 5, 6]
        this.gameRank = [...this.gameTotal]

        this.gameRankShuffled = this.shuffle( this.gameRank)

        this.finalRandomizer = [];

      

        for (let i = 0; i < this.gameTotal.length; i++) {
           
            this.finalRandomizer.push({gameId: this.gameTotal[i]})   
        }

        

        this.finalRandomizer = this.shuffle(this.finalRandomizer)
        this.finalRandomizer.pop()
        this.finalRandomizer.pop()

        this.fiterDataBasedOnRank(this.finalRandomizer)

    }

    fiterDataBasedOnRank(array) {


        for (let j = 0; j < array.length; j++) {
            

            const element = array[j]


            if(j === 0 || j === 1) {

              
                
                // console.log(element.gameId)
                this.matchingGame = this.data.find(game => { return game.id === element.gameId})
               

                this.allQuestionsDebutant = this.matchingGame.questions.filter((question) => {
                    return question.difficulty === "débutant"
                })

                this.finalQuestion = this.allQuestionsDebutant[Math.floor(Math.random()*this.allQuestionsDebutant.length)]

                this.gameObj = {gameId: element.gameId, titre: this.matchingGame.titre, consigne: this.matchingGame.consigne, question: this.finalQuestion}
                
                this.finalData.push(this.gameObj)

               
            }

            if(j === 2 || j === 3) {

    
                // console.log(element.gameId)
                this.matchingGame = this.data.find(game => { return game.id === element.gameId})
                

                this.allQuestionsDebutant = this.matchingGame.questions.filter((question) => {
                    return question.difficulty === "avancé"
                })

                this.finalQuestion = this.allQuestionsDebutant[Math.floor(Math.random()*this.allQuestionsDebutant.length)]

                this.gameObj = {gameId: element.gameId, titre: this.matchingGame.titre, consigne: this.matchingGame.consigne, question: this.finalQuestion}
                
                this.finalData.push(this.gameObj)

            }
        }

        // console.log(this.finalData)

    }

  


    shuffle(array) {
        return array.slice().sort(() => Math.random() - 0.5);
    }

   

    validator(gameId, gameIndex, ogData, valueToValidate, recapData, difficulty) {
        if(gameId === 1) {
            if(parseInt(valueToValidate) === parseInt(ogData)) {
                this.setScore(difficulty, "good")
                this.fillRecap(recapData, gameIndex, "good", gameId)
                this.animation.endGame('.bonne-rep-view', gameId);
              

                // console.log("good")
                //  console.log(valueToValidate)
                // console.log(ogData)
                
            } else {
                this.setScore(difficulty, "bad")
                this.fillRecap(recapData, gameIndex, "bad", gameId)
                this.animation.endGame('.mauvaise-rep-view', gameId);
                


                // console.log("bad")
                // console.log(valueToValidate)
                // console.log(ogData)
                
            }

        } else if(gameId === 2) {

            if(ogData.includes(valueToValidate)) {
                this.setScore(difficulty, "good")
                this.fillRecap(recapData, gameIndex, "good", gameId)
                this.animation.endGame('.bonne-rep-view', gameId);
            } else {
                this.setScore(difficulty, "bad")
                this.fillRecap(recapData, gameIndex, "bad", gameId)
                this.animation.endGame('.mauvaise-rep-view', gameId);
                
            
            }
        
        } else if(gameId === 3) {

            // console.log(ogData)

            if(ogData === valueToValidate) {
                this.setScore(difficulty, "good")
                this.fillRecap(recapData, gameIndex, "good", gameId)
                this.animation.endGame('.bonne-rep-view');
            } else {
                this.setScore(difficulty, "bad")
                this.fillRecap(recapData, gameIndex, "bad", gameId)
                this.animation.endGame('.mauvaise-rep-view', gameId);
            }
        } else if(gameId === 4) {


            if(ogData.find(element => element === valueToValidate)) {
                this.setScore(difficulty, "good")
                this.fillRecap(recapData, gameIndex, "good", gameId)
                this.animation.endGame('.bonne-rep-view', gameId);
            } else {
                this.setScore(difficulty, "bad")
                this.fillRecap(recapData, gameIndex, "bad", gameId)
                this.animation.endGame('.mauvaise-rep-view', gameId);
                
              
            }
        
        } else if(gameId === 5) {
            if(ogData.includes(valueToValidate)) {
                this.setScore(difficulty, "good")
                this.fillRecap(recapData, gameIndex, "good", gameId)
                this.animation.endGame('.bonne-rep-view', gameId);
            } else {
                this.setScore(difficulty, "bad")
                this.fillRecap(recapData, gameIndex, "bad", gameId)
                this.animation.endGame('.mauvaise-rep-view', gameId);
               
               
            }
        
        } else if(gameId === 6) {
            if(valueToValidate === ogData) {
                this.setScore(difficulty, "good")
                this.fillRecap(recapData, gameIndex, "good", gameId)
                this.animation.endGame('.bonne-rep-view', gameId);

            } else {
                this.setScore(difficulty, "bad")
                this.fillRecap(recapData, gameIndex, "bad", gameId)
                this.animation.endGame('.mauvaise-rep-view', gameId);
              
            }
        }
    }



    gameOne() {



        this.gameOneData = this.finalData.filter((game) => {
                return game.gameId === 1
        })


        this.gameIndex = this.finalData.findIndex(game => game.gameId === 1)
        this.gameNum = this.gameOneData[0].gameId
        this.questionFinal = this.gameOneData[0].question;
        
        
    
            this.gameInfos(this.gameOneData[0].consigne, this.gameIndex + 1, this.gameOneData[0].titre)
            this.createPastilleConseil(this.questionFinal.conseil, this.gameNum);
            this.startPastille()


            this.phraseGame1.innerHTML = this.questionFinal.phrase;

            if(this.questionFinal.source) {
                this.sourceGame1.innerHTML = this.questionFinal.source;
                this.sourceGame1.style.display = 'block'
            } else {
                this.sourceGame1.remove()
            }
     

            this.slider = document.querySelector('.slider')

            // bug here
            this.slider.setAttribute('min', parseInt(this.questionFinal.slider.min))
            this.slider.setAttribute('max', parseInt(this.questionFinal.slider.max))

            this.min.innerHTML = this.questionFinal.slider.min;
            this.max.innerHTML = this.questionFinal.slider.max;

            this.slider.addEventListener("input",(e) =>{
                 this.repSlider.innerHTML = this.slider.value
            })

            this.validateOneBtn.addEventListener('click', (e) => {
            
                this.validator(1, this.gameIndex, this.questionFinal.correction.reponse, this.slider.value, this.questionFinal.correction, this.questionFinal.difficulty);

                if(this.gameIndex + 1 === 4) {
                    this.prepareEndGame()
                } else {
                    this.prepareNextGame(this.finalData[this.gameIndex + 1].gameId, this.gameOneData[0].gameId);
                }
            }, {once :true})
        }
    
    
    prepareEndGame() {
       

        this.nextButton.forEach(element => {
            element.addEventListener('click', () => {
                this.dynamicMetaOG()
                this.animation.nextGame(['.bonne-rep-view', '.mauvaise-rep-view'], '.recap')
                this.fillEndGame(this.score)
                document.querySelector('.gameWrapper').remove()
       
            }, {once: true})             
        })

        this.replayBtn.addEventListener('click', () => {
            window.location.href = '/rejouer.html'
        }, {once: true})
    }

    // gameId
    prepareNextGame(number, sectionNumber) {

       

        this.animation.hidePastille(this.pastilleContainer)
        this.nextButton = [];
        this.nextButton = [...document.querySelectorAll('.next')];

        this.sectionRemove = document.querySelector(`.jeu-${sectionNumber}`)

        if(number === 1) {
            //Recap
            this.nextButton.forEach(element => {
                element.addEventListener('click', () => {
                    this.gameOne()
                    this.animation.nextGame(['.bonne-rep-view', '.mauvaise-rep-view'], '.jeu-1')
                    
                    this.sectionRemove.remove()
                    
                }, {once: true})             
            })

        } else if(number === 2) {
                //Recap
                this.nextButton.forEach(element => {
                    element.addEventListener('click', () => {
                        this.gameTwo()
                        this.animation.nextGame(['.bonne-rep-view', '.mauvaise-rep-view'], '.jeu-2')
                        
                        this.sectionRemove.remove()
                        
                    }, {once: true})             
                })
            
        } else if (number === 3) {
           
                this.nextButton.forEach(element => {
                    element.addEventListener('click', () => {
                        this.gameThree()
                        this.animation.nextGame(['.bonne-rep-view', '.mauvaise-rep-view'], '.jeu-3')
                        
                        this.sectionRemove.remove()
                   
                    }, {once: true})             
                })
        
                  
                      
        } else if (number === 4) {
           
            this.nextButton.forEach(element => {
                element.addEventListener('click', () => {
                    this.gameFour()
                    this.animation.nextGame(['.bonne-rep-view', '.mauvaise-rep-view'], '.jeu-4')
                   
                    this.sectionRemove.remove()
               
                }, {once: true})             
            })
    
              
        } else if (number === 5) {
           
            this.nextButton.forEach(element => {
                element.addEventListener('click', () => {
                    this.gameFive()
                    this.animation.nextGame(['.bonne-rep-view', '.mauvaise-rep-view'], '.jeu-5')
                   
                    this.sectionRemove.remove()
               
                }, {once: true})             
            })
    
              
        } else if (number === 6) {
           
            this.nextButton.forEach(element => {
                element.addEventListener('click', () => {
                    this.gameSix()
                    this.animation.nextGame(['.bonne-rep-view', '.mauvaise-rep-view'], '.jeu-6')
               
                this.sectionRemove.remove()
           
            }, {once: true})             
        })

        }
     
    }


    setScore(questionDifficulty, goodOrBad) {

        if(questionDifficulty === "débutant" && goodOrBad === "good") {
            this.score += 1;
        } else if(questionDifficulty === "avancé" && goodOrBad === "good") {
            this.score += 1;
        } else if(goodOrBad === "bad"){
            this.score += 0;
        }
    }

 

    
    mergePhrase(gameNum, gameIndex, phrase, reponse, ogData, recapData, difficulty) {
       this.phrase1 = phrase.replace("<div class='space'></div>", reponse);
       this.validator(gameNum, gameIndex, ogData, this.phrase1, recapData, difficulty)
    }

  

    gameTwo() {

        this.gameTwoData = this.finalData.filter((game) => {
            return game.gameId === 2
        })

        

        this.gameIndex = this.finalData.findIndex(game => game.gameId === 2)
        this.gameNum = this.gameTwoData[0].gameId

        this.questionFinal = this.gameTwoData[0].question;
       
        this.gameInfos(this.gameTwoData[0].consigne, this.gameIndex + 1, this.gameTwoData[0].titre)
        
       
        this.reponses = [...this.questionFinal.reponses];
        this.phrase = this.questionFinal.phrase;
        this.correction =  this.questionFinal.correction.final;

        this.phraseGame2.innerHTML = this.questionFinal.phrase;

        if(this.questionFinal.source) {
            this.sourceGame2.innerHTML = this.questionFinal.source;
        } else {
            this.sourceGame2.remove()
        }
       
        this.reponses.forEach(element => {
            const rep = document.createElement('button');
            const newContent = document.createElement('p');
            newContent.innerHTML = element
            rep.classList.add("qcm-btn");

            if(element === "les deux") {
                // console.log(element)
                newContent.classList.add('qcm-ita')
                const image = document.createElement('img');
                image.setAttribute('src', '../assets/img/deux.svg')
                image.classList.add('qmc-img')
                rep.appendChild(image);
            } else if(element === "les trois") {
                // console.log(element)
                newContent.classList.add('qcm-ita')
                const image = document.createElement('img');
                image.setAttribute('src', '../assets/img/trois.svg')
                image.classList.add('qmc-img')
                rep.appendChild(image);
            } else if(element === "un autre") {
                // console.log(element)
                newContent.classList.add('qcm-ita')
                const image = document.createElement('img');
                image.setAttribute('src', '../assets/img/autre.svg')
                image.classList.add('qmc-img')
                rep.appendChild(image);
            }

            rep.appendChild(newContent);
            rep.addEventListener('click', (e) => {
             
       
                this.mergePhrase(2, this.gameIndex, this.phrase, element, this.correction, this.questionFinal.correction, this.questionFinal.difficulty)
                
                if(this.gameIndex + 1 === 4) {
                    this.prepareEndGame()
                } else {
                    this.prepareNextGame(this.finalData[this.gameIndex + 1].gameId, this.gameTwoData[0].gameId);
                }


            }, {once: true})
            this.qcmZone2.appendChild(rep);
        });
    

        this.createPastilleConseil(this.questionFinal.conseil,  this.gameNum);
        this.startPastille()

        // console.log(this.reponses);

       

    }

    gameThree() {

        this.gameThreeData = this.finalData.filter((game) => {
            return game.gameId === 3
        })


        this.gameIndex = this.finalData.findIndex(game => game.gameId === 3)
        this.gameNum = this.gameThreeData[0].gameId

        this.questionFinal = this.gameThreeData[0].question;
        this.reponses = [...this.questionFinal.reponses];
        this.correction = this.questionFinal.correction.correct;
        // console.log(`son: ${this.correction}`)

        this.gameInfos(this.gameThreeData[0].consigne, this.gameIndex + 1, this.gameThreeData[0].titre)

        this.createPastilleConseil(this.questionFinal.conseil, this.gameNum);
        this.startPastille()

        this.phraseGame3.innerHTML = this.questionFinal.phrase;

        if(this.questionFinal.source) {
            this.sourceGame3.innerHTML = this.questionFinal.source;
        } else {
            this.sourceGame3.remove()
        }


        this.reponses.forEach(element => {

            const repContainer = document.createElement('div'); 
            repContainer.classList.add('son-container')

            const rep = document.createElement('button');
            rep.classList.add('qcm-btn')
            const newContent = document.createTextNode(element.reponse);
            rep.appendChild(newContent);

            const btnPlayAudio = document.createElement('button');
            btnPlayAudio.classList.add('button-son')
            const btnPlayImage = document.createElement('img')
            btnPlayImage.setAttribute('src', '../assets/img/soundup.svg')
            btnPlayAudio.appendChild(btnPlayImage)
            btnPlayAudio.addEventListener('click', ()=> {

                if(!this.sound) {
                    this.sound = new Audio(`../assets/audio/${element.son}.mp3`)
                    this.sound.play();
                } else {
                    this.sound.pause()
                    this.sound = null;
                    this.sound = new Audio(`../assets/audio/${element.son}.mp3`)
                    this.sound.play();
                }
               
            })
        
            repContainer.appendChild(btnPlayAudio)
            repContainer.appendChild(rep)

           
            rep.addEventListener('click', (e) => {

               
                this.validator(3, this.gameIndex, this.correction, element.reponse, this.questionFinal.correction, this.questionFinal.difficulty);
                
                if(this.gameIndex + 1 === 4) {
                    this.prepareEndGame()
                } else {
                    this.prepareNextGame(this.finalData[this.gameIndex + 1].gameId, this.gameThreeData[0].gameId);
                }

            }, {once: true})

            this.qcmZone3.appendChild(repContainer);
        });
       

    }
    gameFour() {

        this.gameFourData = this.finalData.filter((game) => {
            return game.gameId === 4
        })


        this.gameIndex = this.finalData.findIndex(game => game.gameId === 4)
        this.gameNum = this.gameFourData[0].gameId

        this.questionFinal = this.gameFourData[0].question;

        this.phrase4 = this.questionFinal.phrase.replace(',', '').replace(',', '').replace('?', '').replace(';', '').replace('.', ' .').split(' ')
        this.phrase4 = this.phrase4.filter(e =>  e);
     

        if(this.questionFinal.source) {
            this.sourceGame4.innerHTML = this.questionFinal.source
        } else {
            this.sourceGame4.remove()
        }
    
        
        this.gameInfos(this.gameFourData[0].consigne, this.gameIndex + 1, this.gameFourData[0].titre)
        this.createPastilleConseil(this.questionFinal.conseil, this.gameNum);
        this.startPastille()

        //je genere tous les elements draggable : visuals coming soon
        // console.log(this.phrase4)

       this.phrase4.forEach(el => {
            const elementDraggable = document.createElement('div');
            const elementContent = document.createTextNode(el);
            elementDraggable.appendChild(elementContent);
            elementDraggable.classList.add('drag4')
            this.draggable4.appendChild(elementDraggable);
       });

       
      
       this.createPunctuationToolBox(this.questionFinal.ponctuation, 4)

       this.tempPhrase;
       // TODO event au drag, au changement du drag, on persiste la tempPhrase et on vérifie qu'il est rempli 
       new Sortable(this.ponctuationZone4, {
        group: {
            name: 'shared',
            pull: 'clone',
            put: false, // Do not allow items to be put into this list
            sort: false,
        },
        animation: 150,
        sort: false, 
        onEnd: (evt) => {
           
            this.dragPhrase('.draggable4', 4)

            
           if(evt.item.parentNode.classList.contains('ponctuationZone4')) {
                return
           } else {
             

                if(evt.item.classList.contains('ponctuations-btn')) {
                this.createBtnDelete(evt.item, 4)
                }

                evt.item.classList.remove('ponctuations-btn')
                evt.item.classList.add('drag4', 'punctzer')
            }
               
                
            }
        });

        new Sortable(this.draggable4, {
            group: 'shared',
            animation: 150,
            onEnd: (evt) => {

                this.dragPhrase('.draggable4', 4)
        
                if(evt.item.classList.contains('punctzer')) {
               
                  evt.item.childNodes[1].remove()
                  this.createBtnDelete(evt.item, 4)

                }
                
            }
        });



       this.validateDrag.addEventListener('click', ()=> {
            this.validator(4, this.gameIndex, this.questionFinal.correction.final, this.tempPhrase, this.questionFinal.correction, this.questionFinal.difficulty)
           
            if(this.gameIndex + 1 === 4) {
                this.prepareEndGame()
            } else {
                this.prepareNextGame(this.finalData[this.gameIndex + 1].gameId, this.gameFourData[0].gameId);
            }
       }, {once: true})
    }

    createBtnDelete(ogEl, gameId) {
        document.createElement('button')

        const btnDeletePunctuation = document.createElement('button');
        btnDeletePunctuation.classList.add('button-deletepunct')
        const crossImage = document.createElement('img')
        crossImage.setAttribute('src', '../assets/img/close.svg')
        btnDeletePunctuation.appendChild(crossImage)

        btnDeletePunctuation.addEventListener('click', () => {

            // console.log("click")
            ogEl.remove()
           

            if(gameId === 4) {
                this.dragPhrase('.draggable4', 4)
            } else if(gameId === 5) {
                this.dragPhrase('.jeu-5 .phrase', 5)
            }
        
        }, {once: true})

        ogEl.appendChild(btnDeletePunctuation)
    }


    capitalize(str) {
        const lower = str.toLowerCase();
        return str.charAt(0).toUpperCase() + lower.slice(1);
    }


    
    gameFive() {

        this.gameFiveData = this.finalData.filter((game) => {
            return game.gameId === 5
        })


        this.gameIndex = this.finalData.findIndex(game => game.gameId === 5)
        this.gameNum = this.gameFiveData[0].gameId
        this.questionFinal = this.gameFiveData[0].question;

        this.createPunctuationToolBox(this.questionFinal.ponctuation, 5)


        this.gameInfos(this.gameFiveData[0].consigne, this.gameIndex + 1, this.gameFiveData[0].titre)
        this.createPastilleConseil(this.questionFinal.conseil, this.gameNum);
        
        this.startPastille()


        this.phrase5 = this.questionFinal.phrase.replace(' !', '').replace(',', '').replace(' ?', '').replace(';', '').replace('.', '').split(' ');


        if(this.questionFinal.source) {
            this.sourceGame5.innerHTML = this.questionFinal.source
        } else {
            this.sourceGame5.remove()
        }
    

        this.phrase5.forEach(el => {
            const element = document.createElement('p');
            element.classList.add('drag5')
            const elementContent = document.createTextNode(el);
            element.appendChild(elementContent);
            this.phraseGame5.appendChild(element);
       });

        // TODO event au drag, au changement du drag, on persiste la tempPhrase et on vérifie qu'il est rempli 
        this.tempPhrase;

       

        new Sortable(this.phraseGame5, {
            group: 'shared',
            animation: 150,
            filter: '.drag5',
            onEnd: (evt) => {
              
                evt.item.classList.remove('ponctuations-btn')

                if(evt.item.classList.contains('ponctuations-btn')) {
                    this.createBtnDelete(evt.item, 5)
                }

                this.dragPhrase('.jeu-5 .phrase', 5)
              
            },
        });

        new Sortable(this.ponctuationZone5, {
            group: {
                name: 'shared',
                pull: 'clone',
                put: false // Do not allow items to be put into this list
            },
            animation: 150,
            sort: false, 
            onEnd: (evt) => {
               
              
                if(evt.item.parentNode.classList.contains('ponctuationZone5')) {
                    return
                } else {
                 
    
                    if(evt.item.classList.contains('ponctuations-btn')) {
                    this.createBtnDelete(evt.item, 5)
                    }
    
                }
                   
                    
                this.dragPhrase('.jeu-5 .phrase', 5)
              
             
            },

        
        });

        

        this.validatePonctuation.addEventListener('click', ()=> {
            
            this.validator(5, this.gameIndex, this.questionFinal.correction.final, this.tempPhrase, this.questionFinal.correction, this.questionFinal.difficulty)
           
            if(this.gameIndex + 1 === 4) {
                this.prepareEndGame()
            } else {
            
                this.prepareNextGame(this.finalData[this.gameIndex + 1].gameId, this.gameFiveData[0].gameId);
            }

        }, {once: true})
        
    }

    resetPunctuation(el) {
        
    }

    dragPhrase(draggableClass, gameId) {

        this.bannedLowerCase = ['bretagne', 'calwick', 'bernard', 'granville']

        this.allDraggableText = []

        if(gameId === 4) {
        //Majuscule au début de chaque phrase
            this.othersWords = [...document.querySelectorAll(draggableClass)[0].children];
            this.othersWords.forEach(element => {             
                element.innerHTML = element.innerHTML.toLowerCase()


                if(this.bannedLowerCase.includes(element.innerText)){
              
                    element.innerHTML = this.capitalize(element.innerText)
                }

            });



            this.firstWord = document.querySelectorAll(draggableClass)[0].children[0];
            this.firstWord.innerHTML = this.capitalize(this.firstWord.innerHTML)
            this.allDraggableText.splice(0, 1, this.firstWord.innerHTML)
     
          
            this.allDraggableEl = [...document.querySelectorAll(draggableClass)[0].children]            
            this.allDraggableEl.forEach(element => {
                
                this.allDraggableText.push(element.innerText)
          
                
                if(element.classList.contains('punctzer')) {
                    element.childNodes[1].remove()
                    this.createBtnDelete(element, 4)
                }
            });
            // console.log(this.allDraggableText )

            this.allDraggableText.shift()

        } else {
            this.allDraggableEl = [...document.querySelectorAll(draggableClass)[0].children]        
            
            
            this.allDraggableEl.forEach(element => {
                this.allDraggableText.push(element.innerText)
                element.classList.remove('ponctuations-btn')
            });
           //  console.log(this.allDraggableText )
        }

        

        this.tempPhrase = this.allDraggableText.join(" ")
       //  console.log(this.tempPhrase)

        this.tempPhrase = this.tempPhrase.replace(/(\r\n|\n|\r)/gm, "");
        this.tempPhrase = this.tempPhrase.replace(' ,', ',')
        this.tempPhrase = this.tempPhrase.replace(' , ', ', ')
        this.tempPhrase = this.tempPhrase.replace(' .', '.')
        this.tempPhrase = this.tempPhrase.replace(' !', ' !')
        this.tempPhrase = this.tempPhrase.replace(' ?', ' ?')
        this.tempPhrase = this.tempPhrase.replace(': ', ' : ')

        this.tempPhrase = this.tempPhrase.replace(' « ', '« ')
        this.tempPhrase = this.tempPhrase.replace(' » ', '» ')
        
        this.tempPhrase = this.tempPhrase.replace(' :', ': ')
        this.tempPhrase = this.tempPhrase.replace(' -', '- ')
        
        // console.log(this.tempPhrase)
    }

    fillRecap(correction, gameIndex, status, gameId) {


        if(status === "good") { 

            this.goodContentRecap.innerHTML = '';

           

            if(gameId === 1) {


                //TOP
                this.mention = document.createElement('p')
                this.mention.innerHTML =  "Le compte est bon !";
                this.mention.classList.add("mention")
                //this.bonWrapper.appendChild(this.mention)
                this.goodContentRecap.appendChild(this.mention)
                
                
                //REPONSE
                this.ggf = document.createElement('div')
                this.ggf.classList.add('container-reponse', 'container-response-good')
                this.ggfContent = document.createElement('p')
                this.ggfContent.innerHTML = correction.ggf
                this.ggf.appendChild( this.ggfContent)
                //this.bonWrapper.appendChild(this.ggf)

                this.goodContentRecap.appendChild(this.ggf)
                

                //mots 
                this.bonneRepMots = document.createElement('p')
                this.bonneRepMots.classList.add('words-count', 'ita')
                this.bonneRepMots.innerHTML = `${correction.reponse} mots`
                //this.bonWrapper.appendChild(this.bonneRepMots)
                this.goodContentRecap.appendChild(this.bonneRepMots)



            } else if(gameId === 2) {

                //TOP
                this.mention = document.createElement('p')
                this.mention.innerHTML =  correction.good;
                this.mention.classList.add("mention")
                this.goodContentRecap.appendChild(this.mention)
                
                
                //REPONSE
                this.ggf = document.createElement('div')
                this.ggf.classList.add('container-reponse', 'container-response-good')
                this.ggfContent = document.createElement('p')
                this.ggfContent.innerHTML = correction.ggf
                this.ggf.appendChild( this.ggfContent)
                //this.bonWrapper.appendChild(this.ggf)

                this.goodContentRecap.appendChild(this.ggf)
                

            } else if(gameId === 3) {


                  //TOP
                  this.mention = document.createElement('p')
                  this.mention.innerHTML =  correction.good.headline;
                  this.mention.classList.add("mention")
                  this.goodContentRecap.appendChild(this.mention)
                  

                  this.containerResponse = document.createElement('div')
                  this.containerResponse.classList.add('container-reponse', 'container-response-good')

                  // EXPLICATIONS
                  this.explications = document.createElement('p')
                  this.explications.classList.add('explication')
                  this.explications.innerHTML = correction.good.explication

                  // GGF
                  this.ggfContent = document.createElement('p')
                  this.ggfContent.innerHTML = correction.ggf
                  
            
                  this.containerResponse.appendChild(this.explications)
                  this.containerResponse.appendChild(this.ggfContent)
                  //this.bonWrapper.appendChild(this.ggf)
  
                  this.goodContentRecap.appendChild(this.containerResponse)



                
            } else if(gameId === 4) {
                
                
                
                  //TOP
                  this.mention = document.createElement('p')
                  this.mention.innerHTML =  correction.good;
                  this.mention.classList.add("mention")
                  this.goodContentRecap.appendChild(this.mention)
                  

                  this.containerResponse = document.createElement('div')
                  this.containerResponse.classList.add('container-reponse', 'container-response-good')

                  // EXPLICATIONS
                  if(correction.good.explication) {
                    this.explications = document.createElement('p')
                    this.explications.classList.add('explication')
                    this.explications.innerHTML = correction.good.explication
                    this.containerResponse.appendChild(this.explications)
                  }
             
                  // GGF
                  this.ggfContent = document.createElement('p')
                  this.ggfContent.innerHTML = correction.ggf
                  
        
                  this.containerResponse.appendChild(this.ggfContent)
                  //this.bonWrapper.appendChild(this.ggf)
  
                  this.goodContentRecap.appendChild(this.containerResponse)


            } else if(gameId === 5) {


                   //TOP
                   this.mention = document.createElement('p')
                   this.mention.innerHTML =  correction.good;
                   this.mention.classList.add("mention")
                   this.goodContentRecap.appendChild(this.mention)
                   
                   
                   //REPONSE
                   this.ggf = document.createElement('div')
                   this.ggf.classList.add('container-reponse', 'container-response-good')
                   this.ggfContent = document.createElement('p')
                   this.ggfContent.innerHTML = correction.ggf
                   this.ggf.appendChild( this.ggfContent)
                   //this.bonWrapper.appendChild(this.ggf)
   
                   this.goodContentRecap.appendChild(this.ggf)
                
            } else if(gameId === 6) {
                
                
                  //TOP
                  this.mention = document.createElement('p')
                  this.mention.innerHTML =  correction.good.headline;
                  this.mention.classList.add("mention")
                  this.goodContentRecap.appendChild(this.mention)
                  

                  this.containerResponse = document.createElement('div')
                  this.containerResponse.classList.add('container-reponse', 'container-response-good')

                  // EXPLICATIONS
                  this.explications = document.createElement('p')
                  this.explications.classList.add('explication')
                  this.explications.innerHTML = correction.good.explication

                  // GGF
                  this.ggfContent = document.createElement('p')
                  this.ggfContent.innerHTML = correction.ggf
                  
            
                  this.containerResponse.appendChild(this.explications)
                  this.containerResponse.appendChild(this.ggfContent)
                  //this.bonWrapper.appendChild(this.ggf)
  
                  this.goodContentRecap.appendChild(this.containerResponse)
            } 

        } else {

        

            // this.badRepId.innerHTML = `${gameIndex + 1} `
            this.badContentRecap.innerHTML = '';

            if(gameId === 1) {

                // this.badWrapper.innerHTML = '';

                this.mention = document.createElement('p')
                this.mention.innerHTML =  correction.bad.headline;
                this.mention.classList.add("mention")
                //this.badWrapper.appendChild(this.mention)

               

                this.badContentRecap.appendChild(this.mention)

                //wrapper double col
                this.wrapperInner = document.createElement('div')
                this.wrapperInner.classList.add('col-r-bad-one')
                
                //REPONSE
                this.mauvaiseRep = document.createElement('div')
                this.mauvaiseRep.classList.add('container-reponse', 'container-reponse-game-one')
                this.mauvaiseRepContent = document.createElement('p')


                this.finalSplitted = []

                
                        this.splittedCorrect = correction.bad.correctWas.split(' ')
                        // console.log(this.splittedCorrect)                     
                        // console.log(this.splittedCorrect.find(el => el === "[…]"))

                        this.splittedCorrect.forEach(element => {

                           //  console.log(element)
                            if(element === "!" || element === "?" || element === "[…].") {
                               
                                const el = document.createElement('span')
                                el.classList.add('c1')
                                el.innerHTML = element
                                this.mauvaiseRepContent.appendChild(el)
                                
                                
                            } else {

                                element = element.replace('[', '').replace(']', '').replace('*', ' ')
                                const el = document.createElement('span')
                                el.classList.add('c1')
                                
                                const border = document.createElement('span');
                                border.classList.add('border')
                                
                                el.innerHTML = element
                                el.appendChild(border)
                                this.mauvaiseRepContent.appendChild(el)
                                
                                
                            }

                        
                        })
                

                setTimeout(() => {
                    this.animation.staggerEl()
                }, 1000);

         
              


                this.mauvaiseRep.appendChild( this.mauvaiseRepContent)
              


                //GGF
                this.ggf = document.createElement('div')
                this.ggf.classList.add('container-ggf', 'container-ggf-game-one')
                this.ggfContent = document.createElement('p')
                this.ggfContent.innerHTML = correction.ggfBad
                this.ggf.appendChild( this.ggfContent)
                

                this.wrapperInner.appendChild(this.mauvaiseRep)
                this.wrapperInner.appendChild(this.ggf)

                this.badContentRecap.appendChild(this.wrapperInner)

            

                //mots 
                this.badRepMots = document.createElement('p')
                this.badRepMots.classList.add('words-count')
                this.badRepMots.innerHTML = `${correction.bad.result}`
            
                this.badContentRecap.appendChild(this.badRepMots)


            } else if(gameId === 2) {

                this.mention = document.createElement('p')
                this.mention.innerHTML =  correction.bad.headline;
                this.mention.classList.add("mention") 
                this.badContentRecap.appendChild(this.mention)

                //wrapper double col
                this.wrapperInner = document.createElement('div')
                this.wrapperInner.classList.add('col-r-bad-two')
                
                //REPONSE
                this.mauvaiseRep = document.createElement('div')
                this.mauvaiseRep.classList.add('container-reponse', 'container-reponse-game-two')
                this.mauvaiseRepContent = document.createElement('p')
                this.mauvaiseRepContent.innerHTML = correction.bad.correctWas
                this.mauvaiseRep.appendChild( this.mauvaiseRepContent)
             

                //GGF
                this.ggf = document.createElement('div')
                this.ggf.classList.add('container-ggf', 'container-ggf-game-two')
                this.ggfContent = document.createElement('p')
                this.ggfContent.innerHTML = correction.ggfBad
                this.ggf.appendChild( this.ggfContent)
             
                this.wrapperInner.appendChild(this.mauvaiseRep)
                this.wrapperInner.appendChild(this.ggf)

                this.badContentRecap.appendChild(this.wrapperInner)

            

            } else if(gameId === 3) {


                this.mention = document.createElement('p')
                this.mention.innerHTML =  correction.bad.headline;
                this.mention.classList.add("mention") 
                this.badContentRecap.appendChild(this.mention)

                //wrapper double col
                this.wrapperInner = document.createElement('div')
                this.wrapperInner.classList.add('col-r-bad-one')
                
                //REPONSE
                this.mauvaiseRep = document.createElement('div')
                this.mauvaiseRep.classList.add('container-reponse', 'container-reponse-game-five')
                this.mauvaiseRepContent = document.createElement('p')
                this.mauvaiseRepContent.innerHTML = correction.bad.correctWas
                this.mauvaiseRep.appendChild( this.mauvaiseRepContent)

                const btnPlayAudio = document.createElement('button');
                btnPlayAudio.classList.add('button-son', 'button-son-recap')
                const btnPlayImage = document.createElement('img')
                btnPlayImage.setAttribute('src', '../assets/img/soundup.svg')
                btnPlayAudio.appendChild(btnPlayImage)

                btnPlayAudio.addEventListener('click', ()=> {
    
                    if(!this.sound) {
                        this.sound = new Audio(`../assets/audio/${correction.bad.son}.mp3`)
                        this.sound.play();
                    } else {
                        this.sound.pause()
                        this.sound = null;
                        this.sound = new Audio(`../assets/audio/${correction.bad.son}.mp3`)
                        this.sound.play();
                    }
                   
                })

                this.mauvaiseRep.appendChild(btnPlayAudio)

                
                this.containerResponse = document.createElement('div')
                this.containerResponse.classList.add('container-response-ggf-three')

                // EXPLICATIONS
                this.explications = document.createElement('p')
                this.explications.classList.add('explication')
                this.explications.innerHTML = correction.bad.explication
 
                // GGF
                this.ggfContent = document.createElement('p')
                this.ggfContent.classList.add('ggf-content-in')
                this.ggfContent.innerHTML = correction.ggfBad
                   
             
                this.containerResponse.appendChild(this.explications)
                this.containerResponse.appendChild(this.ggfContent)

                this.wrapperInner.appendChild(this.mauvaiseRep)
                this.wrapperInner.appendChild(this.containerResponse)

                this.badContentRecap.appendChild(this.wrapperInner)
                
            } else if(gameId === 4) {


                this.mention = document.createElement('p')
                this.mention.innerHTML =  correction.bad.headline;
                this.mention.classList.add("mention") 
                this.badContentRecap.appendChild(this.mention)

                //wrapper double col
                this.wrapperInner = document.createElement('div')
                this.wrapperInner.classList.add('col-r-bad-two')
                
                //REPONSE
                this.mauvaiseRep = document.createElement('div')
                this.mauvaiseRep.classList.add('container-reponse', 'container-reponse-game-two')
                this.mauvaiseRepContent = document.createElement('p')
                this.mauvaiseRepContent.innerHTML = correction.bad.correctWas
                this.mauvaiseRep.appendChild( this.mauvaiseRepContent)
        
                //GGF
                this.ggf = document.createElement('div')
                this.ggf.classList.add('container-ggf', 'container-ggf-game-four')
                this.ggfContent = document.createElement('p')
                this.ggfContent.innerHTML = correction.ggfBad
                this.ggf.appendChild( this.ggfContent)
             

                this.wrapperInner.appendChild(this.mauvaiseRep)
                this.wrapperInner.appendChild(this.ggf)

                this.badContentRecap.appendChild(this.wrapperInner)

                
            } else if(gameId === 5) {

                this.mention = document.createElement('p')
                this.mention.innerHTML =  correction.bad.headline;
                this.mention.classList.add("mention") 
                this.badContentRecap.appendChild(this.mention)

                //wrapper double col
                this.wrapperInner = document.createElement('div')
                this.wrapperInner.classList.add('col-r-bad-one')
                
                //REPONSE
                this.mauvaiseRep = document.createElement('div')
                this.mauvaiseRep.classList.add('container-reponse', 'container-reponse-game-five')
                this.mauvaiseRepContent = document.createElement('p')
                this.mauvaiseRepContent.innerHTML = correction.bad.correctWas
                this.mauvaiseRep.appendChild( this.mauvaiseRepContent)

                this.containerResponse = document.createElement('div')
                this.containerResponse.classList.add('container-response-ggf')

                // EXPLICATIONS
                this.explications = document.createElement('p')
                this.explications.classList.add('explication')
                this.explications.innerHTML = correction.bad.explication
 
                // GGF
                this.ggfContent = document.createElement('p')
                this.ggfContent.classList.add('ggf-content-in')
                this.ggfContent.innerHTML = correction.ggfBad
                   
             
                this.containerResponse.appendChild(this.explications)
                this.containerResponse.appendChild(this.ggfContent)

                this.wrapperInner.appendChild(this.mauvaiseRep)
                this.wrapperInner.appendChild(this.containerResponse)

                this.badContentRecap.appendChild(this.wrapperInner)
                
            } else if(gameId === 6) {
                this.mention = document.createElement('p')
                this.mention.innerHTML =  correction.bad.headline;
                this.mention.classList.add("mention") 
                this.badContentRecap.appendChild(this.mention)

                //wrapper double col
                this.wrapperInner = document.createElement('div')
                this.wrapperInner.classList.add('col-r-bad-two')
                
                //REPONSE
                this.mauvaiseRep = document.createElement('div')
                this.mauvaiseRep.classList.add('container-reponse', 'container-reponse-game-two')
                this.mauvaiseRepContent = document.createElement('p')
                this.mauvaiseRepContent.innerHTML = correction.bad.correctWas
                this.mauvaiseRep.appendChild( this.mauvaiseRepContent)
        
                //GGF
                this.ggf = document.createElement('div')
                this.ggf.classList.add('container-ggf', 'container-ggf-game-four')
                this.ggfContent = document.createElement('p')
                this.ggfContent.innerHTML = correction.ggfBad
                this.ggf.appendChild( this.ggfContent)
             

                this.wrapperInner.appendChild(this.mauvaiseRep)
                this.wrapperInner.appendChild(this.ggf)

                this.badContentRecap.appendChild(this.wrapperInner)
            } 
        }
    }

    fillEndGame(score) {
        
     
        document.querySelector('.score-final').innerHTML = score;

       
    }

    createPunctuationToolBox(ponctuation, game) {
        
        ponctuation.forEach(el => {
            const elementPonctuation = document.createElement('div');
            const elementContentPonctuation = document.createElement('p')
            elementContentPonctuation.innerText = el;
            elementPonctuation.appendChild(elementContentPonctuation);
            elementPonctuation.classList.add("ponctuations-btn")
            

            if(game === 4) {
                this.ponctuationZone4.appendChild(elementPonctuation);
            } else if(game === 5) {
                this.ponctuationZone5.appendChild(elementPonctuation);
            }
            
       });
    }

    gameSix() {

        this.gameSixData = this.finalData.filter((game) => {
            return game.gameId === 6
        })


        this.gameIndex = this.finalData.findIndex(game => game.gameId === 6)
        this.gameNum = this.gameSixData[0].gameId
        this.questionFinal = this.gameSixData[0].question;


        this.gameInfos(this.gameSixData[0].consigne, this.gameIndex + 1, this.gameSixData[0].titre)
        this.createPastilleConseil(this.questionFinal.conseil, this.gameNum);
        this.startPastille()
    
        this.reponses = [...this.questionFinal.reponses];
        this.correction = this.questionFinal.correction.correct;

        this.phraseGame6.innerHTML = this.questionFinal.phrase;

        if(this.questionFinal.source) {
            this.sourceGame6.innerHTML = this.questionFinal.source
        } else {
            this.sourceGame6.remove()
        }

        
        this.reponses.forEach(element => {
            
        
            const rep = document.createElement('button');
            rep.classList.add('qcm-btn', 'flag')
            const newContent = document.createTextNode(element);
            rep.appendChild(newContent);
            rep.addEventListener('click', (e) => {
                this.validator(6, this.gameIndex, this.correction, element, this.questionFinal.correction, this.questionFinal.difficulty);
                

                if(this.gameIndex + 1 === 4) {
                    this.prepareEndGame()
                } else {
                    this.prepareNextGame(this.finalData[this.gameIndex + 1].gameId, this.gameSixData[0].gameId);
                }
             
            }, {once: true})

            this.qcmZone6.appendChild(rep);
        });
    }


    createPastilleConseil(conseil, gameId) {

        if(document.querySelector('.pastille-container')) {
            document.querySelector('.pastille-container').remove()
        }

        this.pastilleContainer = document.createElement('div')
        this.pastilleContainer.classList.add('pastille-container')
      
        this.pastille = document.createElement('div')
        // this.pastille.innerHTML = 'i'
        this.pastille.classList.add('pastille')
        this.pastilleImg = document.createElement('img')
        this.pastilleImg.setAttribute("src", '../assets/img/ampoule.svg')
        // this.pastilleImg.classList.add('rotating-i')

        this.pastille.appendChild(this.pastilleImg)
    
        this.pastilleContainer.appendChild(this.pastille)

      

          if(document.querySelector('.header-wrapper') !== null) {
               
            document.querySelector('.header-wrapper').appendChild(this.pastilleContainer)
        }
     
       
        this.pastilleContent.innerHTML = conseil


        setTimeout(() => {
            this.movingPastille(true)     
        }, 500);
       
    }

    startPastille() {
        

        // console.log("event-added")
        
        this.pastille.addEventListener("click", ()=> {
           
            this.movingPastille(false)
            this.animation.openPastille() 
            
        })

        this.pastilleContentBtn.addEventListener("click", ()=> {
           
            this.movingPastille(true)
            this.animation.closePastille()

        })
    }

    movingPastille(moving) {

            let rectangle, circle, radius, rectangleRef;

           
            if(document.querySelector(".transitionPastille")) {
                rectangle = document.querySelector(".transitionPastille");
            }
      
        
           if(document.querySelector(".header-wrapper")) {
               rectangleRef = document.querySelector(".header-wrapper");
                rectangle.style.height = rectangleRef.clientHeight + 'px';
           }

            if(document.querySelector(".gameWrapper")) {
                document.querySelector(".gameWrapper").style.display = 'block';
            }
           
          
            if(document.querySelector(".pastille-container")) {
                circle = document.querySelector(".pastille-container");
                radius = (circle.getBoundingClientRect().right - circle.getBoundingClientRect().left) * 0.5;
            }
            
            
            let borderTop, borderBottom, borderLeft, borderRight;
            borderTop = rectangle.getBoundingClientRect().top; //x
            borderLeft = rectangle.getBoundingClientRect().left; //y
            borderRight = rectangle.getBoundingClientRect().right - radius * 2;
            borderBottom = rectangle.getBoundingClientRect().bottom - radius * 2;

            
            let posX, posY;
            let directionX, directionY;
            //on garde la position vers laquelle le cercle évolue

            //on la met en positif
            directionX = directionY = 1;

            posX = Math.random() * (borderRight - borderLeft) + borderLeft;
            posY = Math.random() * (borderBottom - borderTop) + borderTop;


        let drawFrame = () => {
            posX += directionX * 0.5; 
            posY += directionY * 0.5;

            circle.style.left = posX + "px";
            circle.style.top = posY + "px";

            // vitesse
            if (posX > borderRight || posX < borderLeft) {
                directionX = -directionX; //on inverse la direction
            }

            if (posY > borderBottom || posY < borderTop) {
                directionY = -directionY; 
            }
            
            requestAnimationFrame(drawFrame);

        }

        if(moving === true) {
            drawFrame(); 
        } else {
           
            cancelAnimationFrame(drawFrame)
        }

    }
}